module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#politics",
      toString: function () {
        return this.url;
      }
    }